<template>
  <div class="problemTab">
    <div
      v-if="list.length <= 0"
      class="noData"
      style="height:400px; text-align:center;line-height:300px"
    >
      暂无数据
    </div>
    <ul class="list" v-else>
      <li v-for="(item, index) in list" :key="item.id">
        <div class="problemItem display-flex justify-content-space-between">
          <p>{{ index + 1 }}.{{ item.content }}?</p>
          <span class="time"><i>提问时间</i>{{ item.createtime }}</span>
        </div>
        <div class="proConten">
          <div
            v-if="item.replyContent"
            class="display-flex justify-content-space-between align-items-center"
            style="border-bottom: 1px solid #f1eff2;"
          >
            <div
              class="header display-flex justify-content-space-betweent align-items-center"
            >
              <img v-if="item.teacherImg" :src="item.teacherImg"  alt="头像" />
              <img
                v-else
                src="../../assets/img/header.jpg"
                onerror="javascript:this.src='../../assets/img/header.jpg'"
                alt="头像"
              />
              <span class="name">{{ item.teacherName}}</span>
            </div>
            <span class="time"><i>回复时间</i>{{ item.replytime }}</span>
          </div>
          <div>

            <p class="content" v-if="item.replyContent" v-html="item.isShowAll ? item.replyContent : item.replyCont">
              <!-- {{ item.isShowAll ? item.replyContent : item.replyCont }} -->
            </p>
            <span v-else class="noData">TA还没有回复哦</span>
            <div class="more">
              <button
                type="button"
                @click="item.isShowAll = !item.isShowAll"
                v-if="item.replyContenLength > 90 "
              >
              {{item.isShowAll?"收起":"查看更多"}}
                
              </button>
            </div>
          </div>
        </div>
        <div class="proFooter">
          <button
            v-if="!item.evalContent && !item.evalType && item.replyContent"
            type="button"
            class="evalBtn"
            @click="handleToEval(item)"
          >
            评价结果
          </button>
          <div class="result">
            <div
              v-if="item.evalType || item.evalContent"
              class="resultEvel display-flex justify-content-space-between"
            >
              <h5>
                我的评价
                <span
                  v-if="item.evalType"
                  :class="item.evalType == '不满意' ? 'r2' : 'r1'"
                  >{{ item.evalType }}</span
                >
              </h5>
              <span class="time">{{ item.updatetime }}</span>
            </div>
            <p>
              {{ item.evalContent }}
            </p>
          </div>
        </div>
      </li>
    </ul>
    <div class="page">
      <Page
        v-if="totalPage > 0"
        :total="totalPage"
        show-elevator
        show-total
        class-name="pageItem"
        @on-change="handleChangePage"
      >
      </Page>
    </div>
  </div>
</template>

<script>
import { postData, showLoading } from "../../assets/api/api.js";
export default {
  name: "problemTab",
  components: {},
  props: ["state"],
  data() {
    return {
      page: 0,
      size: 10,
      totalPage: 0,
      list: [],
    };
  },
  created() {
    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    loadData() {
      const { page, size, state } = this;
      var status = state == "all" ? "" : state;
      var params = {
        currentPage: page,
        pageSize: size,
        state: status,
      };
      showLoading();
      postData("message/ListPage", params).then((res) => {
        if (res.data) {
          if (res.data.entities) {
            res.data.entities.forEach((i) => {
              // i.teacherName = "罗友香"
              // i.teacherImg = "https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1590239587&di=7f1cb2eb63ba279f38fc718d2fd05196&src=http://a2.att.hudong.com/36/48/19300001357258133412489354717.jpg"
              i.teacherName = i.teacherName || i.adminName
              i.teacherImg = i.teacherImg || require('../../assets/img/header.jpg')
              i.isShowAll = false;
              if (i.replyContent) {
                i.replyContenLength = i.replyContent.length;
                // i.isShowBtn =  i.replyContenLength > 90?true:false
                
                i.replyCont =
                  i.replyContenLength > 90
                    ? `${i.replyContent.substring(0, 90)}...`
                    : i.replyContent;
              }
            });
            this.list = res.data.entities;
            this.totalPage = res.data.pageCount;
          } else {
            this.list = [];
          }
        } else {
          this.list = [];
        }
      });
    },
    handleToEval(item) {
      this.$router.push({
        path: "/attendanceProcess/eval",
        query: {
          id: item.id,
        },
      });
    },
    handleChangePage(page) {
      this.page = page - 1;
      this.loadData();
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  margin: 0 30px;
  li {
    .proFooter {
      border-bottom: 1px solid #f5f4f7;
      .result {
        p {
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
          margin-bottom: 20px;
        }
        .resultEvel h5 {
          margin-top: 20px;
          margin-bottom: 25px;
          font-size: 16px;
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
          .r1 {
            color: #31af58;
            margin-left: 10px;
          }
          .r2 {
            color: #ec6941;
            margin-left: 10px;
          }
        }
      }
      .evalBtn {
        margin-top: 15px;
        margin-bottom: 25px;
        width: 120px;
        height: 36px;
        background: rgba(49, 175, 88, 1);
        border-radius: 4px;
        color: rgba(255, 255, 255, 1);
        line-height: 36px;
      }
    }
    .noData {
      color: #999999;
      font-size: 16px;
      display: block;
      line-height: 90px;
      text-align: center;
    }
    .proConten {
      padding-left: 20px;
      padding-right: 20px;
      background: #fafafc;
      border: 1px solid #f5f4f7;
      .more {
        text-align: center;
        padding-bottom: 15px;
        button {
          width: 120px;
          height: 30px;
          line-height: 30px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(153, 153, 153, 1);
          border-radius: 4px;
          color: rgba(102, 102, 102, 1);
        }
      }
      .content {
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
        padding-bottom: 25px;
        padding-top: 24px;
        min-height: 90px;
      }
      .header {
        padding: 15px 0;

        img {
          margin-right: 10px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
      }
    }
    .time {
      color: rgba(170, 170, 170, 1);
      line-height: 20px;
      i {
        margin-right: 15px;
      }
    }
    .problemItem {
      margin-bottom: 15px;
      margin-top: 20px;
      p {
        padding-right: 20px;
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
      }
    }
  }
  li:first-child .problemItem {
    margin-top: 5px;
  }
}
</style>
